module.exports = __webpack_public_path__ + "static/media/mail-bulk.b271267e.svg";